export default "は\nまたは\nどこ\n何\nどうやって\n幾つか\nいくら\nすべき\nできる"